/**
 * src/core/rollen.ts — Rollen-Bezeichnungen für die TS-Module, aus derselben Quelle wie die Team-App
 * Modul: Auth · Zuletzt geändert: 2026-10-10 (S2, C10)
 *
 * C10 «Rollen und Stufen aus einer Quelle (Frontend-Maps entfernen)», Entscheid Haupt 10.10. 15:47: die Bezeichnung
 * kommt aus der Tabelle `rollen` (api/team.php action=rollen). Die eine Quelle im Frontend ist js/form.js
 * (nvRolleBezeichnung, nvRollenAuswahl, mit dem einzigen Rückfall NV_ROLLEN_RUECKFALL). Dieses Modul führt KEINE eigene
 * Liste; es fragt die globalen Funktionen. Fehlen sie (Test, Seite ohne form.js), gilt der Rollen-Schlüssel selbst —
 * nie eine leere Anzeige. Nur Anzeige: keine Rechteprüfung liest die Bezeichnung.
 */

interface RollenGlobal {
  nvRolleBezeichnung?: (r: string) => string;
  nvRollenAuswahl?: (aktuell: string) => { wert: string; bezeichnung: string }[];
}

function g(): RollenGlobal {
  return (typeof window !== 'undefined' ? (window as unknown as RollenGlobal) : {});
}

/** Bezeichnung einer Rolle; ohne Quelle der Schlüssel selbst. */
export function rolleBezeichnung(role: string): string {
  const f = g().nvRolleBezeichnung;
  const b = typeof f === 'function' ? f(role) : '';
  return b || role;
}

/** Rollen für eine Auswahl (nur vergebbare, dazu die aktuelle); ohne Quelle nur die aktuelle. */
export function rollenAuswahl(aktuell: string): { wert: string; bezeichnung: string }[] {
  const f = g().nvRollenAuswahl;
  if (typeof f === 'function') return f(aktuell);
  return aktuell ? [{ wert: aktuell, bezeichnung: aktuell }] : [];
}
